import Immutable from 'immutable';

import {
  LOGIN_SUCCESS,
  AUTH_EXPIRED_ERROR,
  GIVING_PRIVACY_CONSENT_SUCCESS
} from '../actions/login';

const initialState = Immutable.fromJS({
  data: {},
  permissions: []
});

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      const {permissions, ...otherData} = action.data;
      return state.merge({
        data: Immutable.fromJS(otherData),
        permissions: Immutable.fromJS(permissions)
      });
    case AUTH_EXPIRED_ERROR:
      return initialState;
    case GIVING_PRIVACY_CONSENT_SUCCESS:
      return state.setIn(['data', 'privacy'], true);
    default:
      return state;
  }
}

/* Selectors */

export function getUserData(state) {
  return (state && state.getIn(['user', 'data'])) || Immutable.Map();
}

export function getUserPermissions(state) {
  return (state && state.getIn(['user', 'permissions'])) || Immutable.List();
}

export function getUserName(state) {
  return (state && state.getIn(['user', 'data', 'firstName'])) || '';
}

export function getUserUsername(state) {
  return (state && state.getIn(['user', 'data', 'username'])) || '';
}

export function getUserId(state) {
  return (state && state.getIn(['user', 'data', 'id'])) || null;
}

export function getUserFullName(state) {
  const firstName = (state && state.getIn(['user', 'data', 'firstName'])) || '';
  const lastName = (state && state.getIn(['user', 'data', 'lastName'])) || '';

  return `${firstName} ${lastName}`.trim();
}

export function getUserCompany(state) {
  return (state && state.getIn(['user', 'data', 'company'])) || Immutable.Map();
}

/* Permissions */

export function getResourcePermissions(state, resource) {
  const permissions = getUserPermissions(state);
  return permissions.find(perm => perm.get('functionId') === resource);
}

export function hasFullPermission(state, resource) {
  const permissions = getResourcePermissions(state, resource);
  if (!permissions) {
    return false;
  }

  return (
    Boolean(permissions.get('view')) &&
    Boolean(permissions.get('edit')) &&
    Boolean(permissions.get('add')) &&
    Boolean(permissions.get('delete'))
  );
}

export function hasWritePermission(state, resource) {
  const permissions = getResourcePermissions(state, resource);
  if (!permissions) {
    return false;
  }

  return Boolean(permissions.get('add')) && Boolean(permissions.get('edit'));
}

export function getUserRoleId(state) {
  return (
    (state &&
      state.getIn(
        ['user', 'data', 'roleId'],
        state.getIn(['user', 'data', 'role', 'id'])
      )) ||
    null
  );
}

export function getUserRoleName(state) {
  const role = (state && state.getIn(['user', 'data', 'role', 'name'])) || '';

  return role.toString().toLowerCase();
}

export function isAssessor(state) {
  const role = getUserRoleName(state);

  return role === 'assessor' || role === 'admin' || role === 'superassessor';
}

export function hasGivenPrivacyConsent(state) {
  return Boolean(state.getIn(['user', 'data', 'privacy']));
}
